@if (control) {
  @if (buildErrorViewData(); as errData) {
    <div class="error flex flex-col mt-1">
      @for (err of errData.errorText; track index; let first = $first; let last = $last; let index = $index) {
        @if (!first && !last) {
          &nbsp;
        }
        <ng-container
          *ngTemplateOutlet="isErrorTextTemplateRef(err) ? err : plainErrorText; context: { text: err }"
        ></ng-container>
        <ng-container
          *ngTemplateOutlet="
            errData.errorIcon?.[index] ? iconErrorText : undefined;
            context: { text: errData.errorIcon?.[index] }
          "
        ></ng-container>
      }
    </div>
  }
}

<ng-template #plainErrorText let-text="text">
  <p>{{ text | translate }}</p>
</ng-template>

<ng-template #iconErrorText let-text="text">
  <app-info-icon class="align-bottom ml-1" [tooltipText]="text" [tooltipPosition]="'top'"></app-info-icon>
</ng-template>
